import { render, staticRenderFns } from "./SentimentPopular.vue?vue&type=template&id=503efc50&scoped=true"
import script from "./SentimentPopular.vue?vue&type=script&lang=js"
export * from "./SentimentPopular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503efc50",
  null
  
)

export default component.exports